import classnames from 'classnames';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { EventActions } from '../../analytics/uiMetrics';
import useAnalyticEvent, { PageName } from '../../hooks/useAnalyticEvent';
import useWindowLoaded from '../../hooks/useWindowLoaded';
import type { VehicleInfo } from '../../types/vehicleInfo';
import { Body, Container } from './Marketing.styles';

const SummaryTiles = dynamic(() => import('./SummaryTiles'));
const HowItWorks = dynamic(() => import('./HowItWorks'));
const Hero = dynamic(() => import('./Hero'));
const NewHero = dynamic(() => import('./Hero/NewHero'));
const GetValueModule = dynamic(() => import('./GetValueModule'));
const KeyValue = dynamic(() => import('./KeyValue'));
const TakeControl = dynamic(() => import('./TakeControl'));
const FAQSection = dynamic(() => import('./FAQ/FAQ'));

const Marketing = ({
  customVehicleInfo,
  isInNewHeroTreatment
}: {
  customVehicleInfo: VehicleInfo;
  isInNewHeroTreatment: boolean;
}) => {
  const vehicleInfo = customVehicleInfo;
  const isLoaded = useWindowLoaded();
  const { recordGenericPageEvent } = useAnalyticEvent();
  const router = useRouter();

  useEffect(() => {
    if (router.isReady && typeof window !== 'undefined') {
      recordGenericPageEvent(PageName.Marketing, 'Marketing Page', EventActions.Visited, {
        make: vehicleInfo?.vehicleMake,
        model: vehicleInfo?.vehicleModel,
        year: vehicleInfo?.vehicleYear,
        isExactImageMatch: vehicleInfo?.isExactImageMatch,
        searchModel: vehicleInfo?.searchModel,
        searchYear: vehicleInfo?.searchYear
      });
    }
  }, [
    recordGenericPageEvent,
    router.isReady,
    vehicleInfo?.isExactImageMatch,
    vehicleInfo?.searchModel,
    vehicleInfo?.searchYear,
    vehicleInfo?.vehicleMake,
    vehicleInfo?.vehicleModel,
    vehicleInfo?.vehicleYear
  ]);

  return (
    <Container>
      {isLoaded && <SummaryTiles />}
      {isInNewHeroTreatment ? (
        <NewHero customVehicleInfo={vehicleInfo} />
      ) : (
        <Hero customVehicleInfo={vehicleInfo} />
      )}
      <Body className={classnames({ 'new-hero-treatment': isInNewHeroTreatment })}>
        <KeyValue />
        <HowItWorks />
        <TakeControl />
        <GetValueModule />
      </Body>
      <FAQSection />
    </Container>
  );
};

export default Marketing;
